import React from "react";
import { ContactInput } from "@fidget/common/components/chat/contactInput";
import { CollapsibleContainer } from "@fidget/common/components/collapsibleContainer";
import { WidgetCheckboxInput } from "@fidget/common/components/inputs/widgetCheckboxInput/widgetCheckboxInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { TextInput } from "../components/textInput/textInput";
import { LimitedWidgetInputProps, WidgetInputType } from "../types";
import { ContactEnquiryInputs } from "../utils/contactEnquiryFormUtils";
import styles from "./contactEnquiryForm.css";
import { ContactEnquiryConfigContext } from "@closerplatform/spinner-openapi";

interface Props extends LimitedWidgetInputProps {
  phoneRegion: string;
  configContext: ContactEnquiryConfigContext;
}

export const ContactEnquiryForm = ({
  configContext: { gdpr },
  userAnswers,
  onChange,
  phoneRegion,
  formId,
  isSubmitted
}: Props) => {
  return (
    <>
      {isSubmitted ? (
        <TextInput
          input={{
            type: WidgetInputType.Text,
            index: 0,
            name: "contact",
            displayName: intl.formatMessage("widget.contact.input.enterContactLabel")
          }}
          formId={formId}
          isSubmitted={isSubmitted}
          userAnswers={userAnswers}
          onChange={onChange}
        />
      ) : (
        <ContactInput
          onChange={(value) => onChange({ inputName: ContactEnquiryInputs.Contact, value })}
          phoneRegion={phoneRegion}
        />
      )}
      {gdpr.enabled && !!gdpr.text && (
        <div className={styles.gdpr}>
          <>
            <CollapsibleContainer isTextCollapsed text={gdpr.text} />
            <WidgetCheckboxInput
              id={formId + "gdpr-agreement"}
              colorSchema="primary"
              className={styles["checkbox"]}
              label={intl.formatMessage("widget.chat.gdpr.agreementTitle")}
              checked={!!userAnswers[ContactEnquiryInputs.Agreement]?.checked}
              onChange={(checked) =>
                onChange({ inputName: ContactEnquiryInputs.Agreement, checked })
              }
              disabled={isSubmitted}
            />
          </>
        </div>
      )}
    </>
  );
};
